const Loader = ({ size = 'lg' }) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'w-5 h-5 m-0 inline-block';
      case 'md':
        return 'w-12 h-12 m-auto block';
      case 'lg':
      default:
        return 'w-24 h-24 m-auto block';
    }
  };

  return (
    <div className={`${getSizeClasses()} relative`}>
      <div className="absolute inset-0 border-4 border-white/10 rounded-full"></div>
      <div className="absolute inset-0 animate-spin rounded-full border-4 border-body border-t-transparent"></div>
      <span className="sr-only">Chargement...</span>
    </div>
  );
};

export default Loader;
